

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Loader;
